import { CopyText } from '../i18n/Language';
import { useLanguage } from '../i18n/Language';
import ArrowIcon from '../components/ArrowIcon';
import { useEffect } from 'react';
import { Link } from '../i18n/Language';
import ProjectList from '../components/ProjectList';
import LiminalMatrix from '../components/LiminalMatrix';
import { LeadCaptureBox } from '../components/NewsletterPopup';
import { studio, team } from '../data/studio';

export default function Home() {
  const { t } = useLanguage();
  useEffect(() => { document.title = t("Liminality · Web & App Studio"); }, [t]);
  return (
    <>
      <section className="studio-hero studio-container">
        <div className="hero-content">
          <h1><CopyText source={"Websites and apps,"} /><br /><span><CopyText source={"built with you."} /></span></h1>
          <p><CopyText source={"We design and build websites and custom apps for businesses. You work directly with us, from the first conversation to launch."} /></p>
          <Link className="button-dark" to="/contact"><CopyText source={"Start a project"} />{' '}<ArrowIcon /></Link>
        </div>
        <LiminalMatrix />
      </section>

      <section className="studio-container studio-section" id="work">
        <div className="work-heading"><h2><CopyText source={"Our own"} /><br /><CopyText source={"apps."} /></h2><p><CopyText source={"Alongside client work, we build and maintain our own apps."} /><br /><CopyText source={"Explore all of them on Liminality Apps."} /></p></div>
        <ProjectList />
      </section>

      <section className="studio-container studio-section" id="services">
        <h2><CopyText source={"What we"} /><br /><CopyText source={"build."} /></h2>
        <div className="service-list">
          <article><h3><CopyText source={"Websites & web platforms."} /></h3><p><CopyText source={"From company websites and landing pages to web platforms, we build for the people who use them, on any screen."} /></p></article>
          <article><h3><CopyText source={"Apps for phones, computers & Apple Vision Pro."} /></h3><p><CopyText source={"We build custom apps for iPhone, Android, Mac, and Apple Vision Pro, from an early idea through to launch."} /></p></article>
        </div>
      </section>

      <section className="studio-container studio-section team-section" id="team">
        <div className="team-header">
          <h2><CopyText source={"The Team."} /></h2>
          <div>
            <p><CopyText source={"We’re Luca and Michele, the people behind Liminality. When we work together, you talk directly to the people building your product."} /></p>
            <p><CopyText source={"We agree on the scope together and keep you involved as the project takes shape."} /></p>
            <Link className="text-link" to="/contact"><CopyText source={"Tell us what you’re building"} />{' '}<ArrowIcon /></Link>
          </div>
        </div>
        <div className="team-grid">
          {team.map(member => (
            <article className="team-card" key={member.name}>
              <div className="team-person">
                <span className="team-avatar"><img src={member.image} alt={member.name} width="72" height="72" loading="lazy" /></span>
                <div className="team-identity">
                  <span className="team-role"><CopyText source={member.role} /></span>
                  <h3>{member.name}</h3>
                </div>
              </div>
              <p><CopyText source={member.bio} /></p>
              <div className="team-card-footer">
                <span className="team-focus"><CopyText source={member.focus} /></span>
                <div className="team-socials">
                  <a href={member.linkedin} target="_blank" rel="noreferrer" aria-label={t(`${member.name} on LinkedIn`)}>
                    <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true"><path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.28 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.75M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77Z"/></svg>
                  </a>
                  <a href={member.github} target="_blank" rel="noreferrer" aria-label={t(`${member.name} on GitHub`)}>
                    <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true"><path d="M12 2A10 10 0 0 0 2 12c0 4.42 2.87 8.17 6.84 9.5.5.08.66-.23.66-.5v-1.69c-2.77.6-3.36-1.34-3.36-1.34-.46-1.16-1.11-1.47-1.11-1.47-.91-.62.07-.6.07-.6 1 .07 1.53 1.03 1.53 1.03.87 1.52 2.34 1.07 2.91.83.09-.65.35-1.09.63-1.34-2.22-.25-4.55-1.11-4.55-4.92 0-1.11.38-2 1.03-2.71-.1-.25-.45-1.29.1-2.64 0 0 .84-.27 2.75 1.02.79-.22 1.65-.33 2.5-.33.85 0 1.71.11 2.5.33 1.91-1.29 2.75-1.02 2.75-1.02.55 1.35.2 2.39.1 2.64.65.71 1.03 1.6 1.03 2.71 0 3.82-2.34 4.66-4.57 4.91.36.31.69.92.69 1.85V21c0 .27.16.59.67.5C19.14 20.16 22 16.42 22 12A10 10 0 0 0 12 2Z"/></svg>
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>
      <section className="closing-section">
        <div className="studio-container">
          <h2><CopyText source={"Have a project"} /><br /><em><CopyText source={"in mind?"} /></em></h2>
          <div className="closing-cta">
            <p><CopyText source={"Have a website or app in mind? Write to us directly."} /></p>
            <a className="closing-email" href={`mailto:${studio.email}?subject=${encodeURIComponent(t('Let’s talk about a project'))}`}>
              <span className="closing-email-address">{studio.email}</span>
              <span className="closing-email-arrow" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M5 19 19 5M5 5h14v14" /></svg>
              </span>
            </a>
            <LeadCaptureBox source="studio-closing" />
          </div>
        </div>
      </section>
    </>
  );
}
